import React from 'react';
import PropTypes from 'prop-types';
import StyledBidBadge from './Styles';

const propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
  testId: PropTypes.string,
  dataTip: PropTypes.bool,
  dataFor: PropTypes.string
};
const defaultProps = {
  className: undefined,
  variant: undefined,
  children: undefined,
  testId: undefined,
  dataTip: undefined,
  dataFor: undefined
};

const BidBadge = ({
  className,
  variant,
  children,
  testId,
  dataTip,
  dataFor
}) => (
  <StyledBidBadge
    data-testid={testId}
    className={className}
    variant={variant}
    data-tip={dataTip || undefined}
    data-for={dataFor || undefined}
  >
    {children}
  </StyledBidBadge>
);

BidBadge.propTypes = propTypes;
BidBadge.defaultProps = defaultProps;
export default BidBadge;
